import React from 'react';

import styled from 'styled-components';
import RupeeIcon from '../../../../Icons/RupeeIcon';

const TrendingDestinationsUI = ({
  trendingCityList,
  text,
  clickHandler,
  homePageClicksGAHandler,
}) => {
  return (
    <ListRecentTrendWrapper>
      <ListTrendingWrapper>
        <ListRecentHeadText>{text}</ListRecentHeadText>
        <ListTrendInnerWrap>
          {trendingCityList.map(item => {
            const {img_processed = {}, asp = '', h_text = ''} = item;
            return (
              <React.Fragment key={item.lid}>
                <li
                  onClick={() => {
                    clickHandler(item);
                    homePageClicksGAHandler(item.h_text);
                  }}
                >
                  <TrendingDateImg
                    src={img_processed['landscape']['jpg']['g'] || ''}
                    alt={img_processed['landscape']['jpg']['g'] || ''}
                  />
                  <PopularBigImageOverlayWrap>
                    <OverlayMainText>{h_text}</OverlayMainText>
                    {asp ? (
                      <OverlaySubText>
                        Starts at <RuppeIconList />
                        {asp}/night
                      </OverlaySubText>
                    ) : (
                      ''
                    )}
                  </PopularBigImageOverlayWrap>
                </li>
              </React.Fragment>
            );
          })}
        </ListTrendInnerWrap>
      </ListTrendingWrapper>
    </ListRecentTrendWrapper>
  );
};

const ListRecentTrendWrapper = styled.div(
  props => `
    width: 100%;
    flex-direction: column;
    display: flex;
    padding: ${props.theme.spacing.large.l20};
  `,
);

const ListRecentSearchWrapper = styled.div(
  props => `
    width: 100%;
    flex-direction: column;
    display: flex;
  `,
);

const ListRecentHeadText = styled.span(
  props => `
    display: flex;
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.grey75};
  `,
);

const ListTrendingWrapper = styled.div(
  props => `
    display: flex;
    width:100%;
    // padding-top: ${props.theme.spacing.large.l25};
    flex-direction: column;
  `,
);

const ListTrendInnerWrap = styled.ul(
  props => `
    width: 100%;
    padding-top: ${props.theme.spacing.base};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    li{
      width: 15.3rem;
      display: inline-flex;
      margin-bottom: ${props.theme.spacing.large.l20};
      position: relative;
    }
  `,
);

const TrendingDateImg = styled.img(
  props => `
    width: 15.3rem;
    height: 8rem;
    display: flex;
    position: relative;
    border-radius: ${props.theme.misc.borderRadius.base};
    object-fit: cover;
  `,
);

const PopularBigImageOverlayWrap = styled.div(
  props => `
        position: absolute;
        top:0;
        left:0;
        width: 15.3rem;
        height: 8rem;
        background-image: linear-gradient(${props.theme.colors.shadow.light}, ${props.theme.colors.shadow.dark});
        border-radius: ${props.theme.misc.borderRadius.base};
        flex-direction: column;
        justify-content: flex-end;
        display: flex;
        padding: ${props.theme.spacing.base};
    `,
);

const OverlayMainText = styled.p(
  props => `
        font-weight:bold;
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};
    `,
);

const OverlaySubText = styled.p(
  props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.white.base};
    `,
);

const RuppeIconList = styled(RupeeIcon)(
  props => `
    fill: ${props.theme.colors.white.base};
    width: .7rem;
    height: .7rem;
  `,
);

export default TrendingDestinationsUI;
